import { useState, useMemo } from 'react';
import { Modal, ModalContent, Input, Button, ModalHeader, Dropdown } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { showroomDesativaSKUAction, showroomListAction, showroomCDAction, showroomAuditoriaAction } from '../../actions/ShowroomActions';



function ModalRemoveProduto({ open, onClose, showroomalocalizacao, showroomCDAction, showroomDesativaSKUAction, userid, isShowroomDesativaLoading, showroomAuditoriaAction, showroomListAction, cdatual }) {

    const [sku, setSku] = useState("");
    const [cd, setCD] = useState("");
    const [localizacao, setLocalizacao] = useState("");
    const [errors, setErrors] = useState({ cd: false, sku: false, localizacao: false });

    const optionscd = [
        { key: 'euclides', text: 'Euclides', value: 1 },
        { key: 'boavista', text: 'Boa Vista', value: 2 }
    ];

    const buscarInfoCD = () => {
        showroomCDAction(cd)
    };

    const handleSave = () => {

        const newErrors = { sku: false, cd: false, localizacao: false };

        if (!sku) newErrors.sku = true;
        if (!cd) newErrors.cd = true;
        if (!localizacao) newErrors.localizacao = true;

        setErrors(newErrors);

        // Verifica se existe algum erro, se sim, não faz nada
        if (Object.values(newErrors).includes(true)) {
            return;
        }


        const data = {
            sku: sku,
            cd: cd == 1 ? 'EUCLIDES' : 'BOA VISTA',
            localizacao: localizacao,
            userid: userid
        }
        console.log(data)
        showroomDesativaSKUAction(data).then(() => {
            showroomListAction(cdatual)
            showroomAuditoriaAction()
            handleModalClose()
            onClose();
        })
    };

    const localizacaoOptions = useMemo(() => {
        return showroomalocalizacao.map(item => ({
            key: item.ID, // ID da localização
            text: item.localizacao, // Nome da localização
            value: item.ID // O dropdown vai armazenar o ID como valor
        }));
    }, [showroomalocalizacao]);


    const handleModalClose = () => {
        // Limpa os campos ao fechar o modal
        setSku("");
    };


    return (
        <>
            <Modal open={open} closeIcon onClose={() => { handleModalClose(); onClose(); }} closeOnDimmerClick={false} >
                <ModalContent>
                    <ModalHeader style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '10px' }}>Remover Produto</ModalHeader>
                    <div style={{ marginBottom: '15px', display: 'flex', gap: '15px' }}>
                        <div style={{ width: '30%' }}>
                            <label style={{ display: 'block', marginBottom: '5px' }}>Centro de distribuição</label>
                            <Dropdown
                                options={optionscd}
                                selection
                                placeholder='Selecione uma CD'
                                name='cd'
                                fluid
                                value={cd || ""}
                                onChange={(e, { value }) => setCD(value)}
                                search
                                style={{ width: '100%' }}
                                error={errors.cd}
                                onBlur={buscarInfoCD}
                            />
                        </div>
                        <div style={{ width: '30%' }}>
                            <label style={{ display: 'block', marginBottom: '5px' }}>Localização</label>
                            <Dropdown
                                options={localizacaoOptions}
                                selection
                                placeholder='Selecione uma localização'
                                name='localizacao'
                                fluid
                                value={localizacao || ""}
                                onChange={(e, { value }) => setLocalizacao(value)}
                                search
                                style={{ width: '100%' }}
                                error={errors.localizacao}

                            />
                        </div>
                        <div>
                            <label style={{ display: 'block', marginBottom: '5px' }}>SKU</label>
                            <Input
                                onChange={(e, { value }) => setSku(value)}
                                name='sku'
                                value={sku}
                                error={errors.sku}
                            // style={{ width: '100%' }}
                            />
                        </div>
                        <div>
                            <Button
                                color="blue"
                                onClick={handleSave}
                                style={{ marginTop: '25px' }}
                                loading={isShowroomDesativaLoading}
                                disabled={isShowroomDesativaLoading}
                            >
                                Salvar
                            </Button>
                        </div>

                    </div>
                </ModalContent>

            </Modal>
        </>
    );
}

const mapStateToProps = (state) => ({
    userid: state.LoginReducer.userid,
    isShowroomDesativaLoading: state.ShowroomReducer.isShowroomDesativaLoading,
    cdatual: state.ShowroomReducer.cdatual,
    showroomalocalizacao: state.ShowroomReducer.showroomalocalizacao
});

export default withRouter(connect(mapStateToProps, {
    showroomDesativaSKUAction,
    showroomListAction,
    showroomCDAction,
    showroomAuditoriaAction
})(ModalRemoveProduto));